
import { CharacterCard } from "./CharacterCard";

interface Character {
  id: string;
  name: string;
  species: string;
  role: string;
  description: string;
  personality: string;
  teaching_focus: string;
  special_talents: string;
  fun_facts: any;
  image_url: string;
  avatar_url: string;
  color_theme: string;
  age_group: string;
  featured: boolean;
}

interface CharactersGridProps {
  characters: Character[];
  isLoading: boolean;
  error: any;
}

export const CharactersGrid = ({ characters, isLoading, error }: CharactersGridProps) => {
  if (error) {
    return (
      <div className="text-center py-12">
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 max-w-md mx-auto">
          <p className="text-red-600">
            Sorry, we couldn't load the characters right now. Please try again later.
          </p>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="bg-white rounded-xl shadow-lg p-6 animate-pulse">
            <div className="w-24 h-24 bg-gray-200 rounded-full mx-auto mb-4"></div>
            <div className="h-6 bg-gray-200 rounded mb-2"></div>
            <div className="h-4 bg-gray-200 rounded mb-4"></div>
            <div className="space-y-2">
              <div className="h-3 bg-gray-200 rounded"></div>
              <div className="h-3 bg-gray-200 rounded"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (characters.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="bg-sky-blue/10 rounded-xl p-8 max-w-md mx-auto">
          <p className="text-gray-600 text-lg">
            No characters match your current filters. Try adjusting your search criteria!
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {characters.map((character) => (
        <CharacterCard key={character.id} character={character} />
      ))}
    </div>
  );
};
